import React from 'react';
import TimelineItem from './TimelineItem';

const experience = [
    {
        title: 'Software Engineer',
        company: 'Veza',
        period: '2026 - Present',
        description: 'Working on cutting-edge IGA solutions as a part of Access Review team.',
    },
    {
        title: 'Software Engineer',
        company: 'Bitstamp',
        period: '2024 - 2026',
        description: 'Outsourced software engineer for Derivatives team. Owned Auto-deleveraging feature from design to production. Worked on multiple projects improving the performance and reliability of the derivatives trading platform.',
    },
    {
        title: 'Lead Software Engineer',
        company: 'GL Charge',
        period: '2023 - 2024',
        description: 'Lead a team of 3 software engineers to build a scalable charging station management system in Go.'
    },
    {
        title: 'Software Engineer',
        company: 'GL Charge',
        period: '2021 - 2023',
        description: 'Worked on a charging station with integrated payment system and a charging station management system.'
    },
    {
        title: 'Software Engineering intern',
        company: 'University of Ljubljana, Faculty of Electrical Engineering',
        period: '2021 - 2021',
        description: 'As a software developer, I designed and developed a charge point for electrical bikes utilizing off-the-shelf hardware. This project was part of my bachelor\'s thesis, which focused on the development of a charging station for electric bikes.'
    },
    {
        title: 'Developer Intern',
        company: 'Syphony Retail AI',
        period: '2019 - 2020',
        description: 'Worked as an intern in the development team of Symphony Retail AI. Bug fixing and occasionally implementing new features.'
    }
];

const education = [
  {
    degree: 'Bachelor\'s Degree',
    school: 'University of Ljubljana, Faculty of Electrical Engineering',
    period: '2018 - 2022',
    description: 'Studied electrical engineering with focus on Information and Communication Technology.'
  }
];

const Resume: React.FC = () => (
  <div>
    <h2 className="text-4xl font-bold gradient-text text-center mb-12">Resume</h2>
    
    <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
      {/* Experience */}
      <div className="vcard-card p-10">
        <h3 className="text-2xl font-bold text-gold mb-6">Experience</h3>
        <div className="space-y-8">
          {experience.map((exp, idx) => (
            <TimelineItem
              key={idx}
              title={exp.title}
              subtitle={exp.company}
              period={exp.period}
              description={exp.description}
            />
          ))}
        </div>
      </div>

      {/* Education */}
      <div className="vcard-card p-10">
        <h3 className="text-2xl font-bold text-gold mb-6">Education</h3>
        <div className="space-y-8">
          {education.map((edu, idx) => (
            <TimelineItem
              key={idx}
              title={edu.degree}
              subtitle={edu.school}
              period={edu.period}
              description={edu.description}
            />
          ))}
        </div>
      </div>
    </div>
  </div>
);

export default Resume; 